import { useForm } from "react-hook-form";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect } from "react";
import { Button } from "antd";
import Select from "../../Components/CommonCommponents/select/Select";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import { dateConverter } from "../../Components/Utilities/util";
import dayjs from "dayjs";

const AddEducation = (props) => {
  console.log("props", props);
  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [educationData, setEducationData] = useState();
  const [educationById, setEducationById] = useState();
  const ANSWER_OPTIONS = [
    { label: "Full time", value: "FULL_TIME" },
    { label: "Part time", value: "PART_TIME" },
    { label: "Correspondence/Distance learning", value: "CORRESPONDENCE" },
  ];
  const educationInfo = async () => {
    await CandodateService.getEducationDetails()
      .then((response) => {
        console.log("response", response.data.data);
      })
      .catch((error) => {});
  };
  const getInfo = async () => {
    await CandodateService.getEducationById(props.educationId)
      .then(
        (oResponse) => {
          console.log("oResponseccc", oResponse.data.data);
          setEducationById(oResponse.data.data);
          getData(oResponse.data.data);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  };

  const getData = (data) => {
    console.log("testdata", data);
    setValue("marks_percentage", data?.marks_percentage);
    setValue("qualification", data?.qualification_name);
    setValue("college", data?.college);
    setValue(
      "course_start_date",
      data?.course_start_date ? dayjs(data?.course_start_date) : ""
    );
    setValue(
      "course_completed_date",
      data?.course_completed_date ? dayjs(data?.course_completed_date) : ""
    );
    setValue("education_type", data?.education_type);
  };
  useEffect(() => {
    getInfo();
    getData();
  }, [props.details]);

  const handleEducationsearch = async (value) => {
    await AuthService.educationDetails(value)
      .then((response) => {
        setEducationData(response.data.data);
        //setSkills(response.data.data.skills)
        //setLocation(response.data.data.location)
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const sendData = async (data) => {
    // const date = dateConverter(data.course_start_date);
    // const course_start_date = date.convertedValue;
    // const date2 = dateConverter(data.course_completed_date);
    // const course_completed_date = date2.convertedValue;
    // data["course_start_date"] = course_start_date;
    // data["course_completed_date"] = course_completed_date;
    data["course_start_date"] = dayjs(data.course_start_date).format('YYYY-MM-DD');
    data["course_completed_date"] = dayjs(data.course_completed_date).format('YYYY-MM-DD');
    data["qualification"] = data.qualification?.value;
    console.log("tetslog", data.qualifications);
    await CandodateService.addEducation(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");

          props.close();
          educationInfo();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const updateData = async (data) => {
    console.log("tetslog", data);
    // const date = dateConverter(data.course_start_date);
    // const course_start_date = date.convertedValue;
    // const date2 = dateConverter(data.course_completed_date);
    // const course_completed_date = date2.convertedValue;
    // data["course_start_date"] = course_start_date;
    // data["course_completed_date"] = course_completed_date;
    data["course_start_date"] = dayjs(data.course_start_date).format('YYYY-MM-DD');
    data["course_completed_date"] = dayjs(data.course_completed_date).format('YYYY-MM-DD');
    data["qualification"] =
      data.qualification.value !== undefined
        ? data?.qualification?.value
        : educationById?.qualification;
    await CandodateService.updateEducation(data, props.educationId)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");

          props.close();
          educationInfo();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onSubmit = async (data) => {
    if (props.educationId) {
      updateData(data);
    } else {
      sendData(data);
    }
  };
  return (
    <div className="w-full pb-6 p-4 flex">
      <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
        <div class="px-2">
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Select
                onSearch={(value) => handleEducationsearch(value)}
                name="qualification"
                placeholder="Search Education"
                label="Education "
                control={control}
                options={educationData?.results?.map((oOption) => {
                  return {
                    value: oOption.option_id,
                    label: oOption.qualification,
                  };
                })}
                showSearch
                rules={{
                  required: "This field is required",
                }}
                className="multiSelect"
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="college"
                label="University/Institute"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>
          {/* <div class="flex -mx-2 md:flex-row flex-col">
                        <div class="w-full px-4">
                            <Input
                                name="first_name"
                                label="Course"
                                control={control}
                                rules={{
                                    required: 'This field is required'
                                }}
                                className="h-12 "
                            />
                        </div>
                    </div> */}
          {/* <div class="flex -mx-2 md:flex-row flex-col">
                        <div class="w-full px-4">
                            <Input
                                name="designation"
                                label="Specialization"
                                control={control}
                                rules={{
                                    required: 'This field is required'
                                }}
                                className="h-12 "
                            />
                        </div>
                    </div> */}
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <RadioGroup
                name="education_type"
                label="CourseType"
                control={control}
                rules={{
                  required: "At least 1 option must be chosen.",
                  maxLength: 20,
                }}
                options={ANSWER_OPTIONS}
              />
            </div>
          </div>
          {/* <div class="flex -mx-2 md:flex-row flex-col">
                        <div class="w-full px-4">
                            <Input
                                name="company"
                                label="Previous Company Name"
                                placeholder=""
                                control={control}
                                rules={{
                                    required: 'This field is required'
                                }}
                                className="h-12 "
                            />
                        </div>
                    </div> */}

          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Course Start Date"
                name="course_start_date"
                noTextInput
                showToday
                rules={{
                  required: "Please Choose a Date",
                }}
                control={control}
                placeholder="Select"
                // disablePreviousDays
                className="h-12"
                disableFutureDays={true}
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Course End Date"
                name="course_completed_date"
                noTextInput
                showToday
                // rules={{
                //     required: 'Please Choose a Date',
                // }}
                control={control}
                placeholder="Select"
                // disablePreviousDays
                className="h-12"
                disableFutureDays={true}
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="marks_percentage"
                label="Mark (%)"
                placeholder=""
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end mt-6 px-4">
          <Button
            htmlType="submit"
            type="submit"
            className="bg-[#000000] text-white text-base rounded-3xl"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddEducation;
